import { MODEL } from "../../";
import { GetInternalMongooseMetaData } from "./utils/GetInternalMongooseMetaData";

/**
 * Helper function that will use reflection on the object given to build out a mongoose object from the
 * model-decorator API
 * 
 * @param constructor: any
 *   The constructor we need to build the mongoose object out of
 * @return: any
 *   Will return a mongoose model object ready to be processed by mongoose
 */
export function GetMongooseMetaData(constructor: any): any {
    let modelOptions = Reflect.getMetadata(MODEL, constructor);
    if (modelOptions !== undefined) {
        return GetInternalMongooseMetaData(constructor);
    }
    return null;
}